import React, { useState } from "react";
import BaseField from "./BaseField";

export default function DateTimeField({
  field,
  value,
  setValue,
  renderInlineChildren,
  openViewer,
  previewMode = false,
}) {
  const required = !!field.required;
  const label = field.label || "Date & Time";
  const mode = field.config?.mode || "datetime"; // date | time | datetime

  const handleChange = (e) => {
    setValue({
      ...(value || {}),
      [mode]: e.target.value,
    });
  };

  const currentValue = value?.[mode] ?? "";

  return (
    <BaseField
      field={field}
      value={value}
      setValue={setValue}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      {/* Label */}
      <h3 className="text-gray-800 dark:text-gray-100 text-lg font-bold mb-3 text-center">
        {label} {required && <span className="text-orange-500">*</span>}
      </h3>

      {/* DateTime input */}
      <input
        type={mode === "date" ? "date" : mode === "time" ? "time" : "datetime-local"}
        value={currentValue}
        onChange={handleChange}
        className="w-full border-2 border-orange-500 rounded-lg p-3 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-orange-400"
      />
    </BaseField>
  );
}
